import { CommonModule, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { LoaderService } from '../../_services/loader.service';

@Component({
  selector: 'app-loader',
  imports: [NgIf,CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  constructor(public loaderService: LoaderService){}

}
